import axios from "axios";
import { AxiosError } from "axios";
import { useApi } from "../hooks/useApi";

const api = useApi();

export async function getSubscriptData(): Promise<{
  id: number;
  type: string;
  subs_start: string;
  subs_end: string;
  next_payment: string;
  isWantPremiumSubs: boolean;
}> {
  try {
    const { data } = await api.get('subscriptions/of-user');
    return data;
  } catch (error) {
    throw error;
  }
}

export async function switchBackToBasicSubscription(subscriptionId: number | undefined): Promise<{ message: string }> {
  if (!subscriptionId) {
    throw new Error('L\'ID de l\'abonnement est requis pour effectuer cette opération.');
  }

  try {
    // Effectuer la requête PUT vers l'API
    const response = await api.put(`subscriptions/indicating-switch-to-basic/${subscriptionId}`);

    // Retourner le message de succès depuis la réponse
    return response.data;
  } catch (error) {

    if (error instanceof AxiosError) {
      const status = error.response?.status || 500;
      const errorMessage = error.response?.data?.message || 'Une erreur est survenue.';
      throw new Error(`Erreur ${status} : ${errorMessage}`);
    }
    else if (error instanceof Error) {
      throw new Error('Impossible de se connecter au serveur. Veuillez vérifier votre connexion.');
    }

    throw new Error('Une erreur inattendue est survenue.');
  }
}

export async function interesedByPremiumSubs() {
  try {
    await api.post('subscriptions/subscription-premium-interes');
    return;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    }
    else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}